/* Copyright (c)2022 Sky Co., LTD. All rights reserved. */

import { AppInfo } from '@/models/AppCatalog/AppInfo';

/// <summary>
/// VPPアプリケーション情報のインターフェース
/// </summary>
/// <remarks>
/// ref: SCV\FrontEndEx\FrontEndEx\Controller\AppController.cs
/// </remarks>
export class Response_VppInfo_ServerIF {
    // VPPアプリケーション一覧
    public vppList = new Array<AppInfo>();
}

/* Copyright (c)2022 Sky Co., LTD. All rights reserved. */
